import moment from 'moment';
import ReservationConstants from '../constants/ReservationConstants';

function isCompletedStatus(status, checkOut) {
	if (!checkOut || !status) {
		return false;
	}

	if (status.toLowerCase() !== ReservationConstants.RESERVATION_STATUS.APPROVED) {
		return false;
	}

	return moment.utc(checkOut).startOf('day').isBefore(moment.utc().startOf('day'));
}

function getBookingStatus(status, t, checkOut) {
	const rawStatus = status;
	status = status.toLowerCase();
	let text = '';

	switch (status) {
		case ReservationConstants.RESERVATION_STATUS.QUOTE:
			text = t('Statuses.Quote');
			break;
		case ReservationConstants.RESERVATION_STATUS.REQUESTED:
			text = t('Statuses.Requested');
			break;
		case ReservationConstants.RESERVATION_STATUS.REJECTED:
			text = t('Statuses.Rejected');
			break;
		case ReservationConstants.RESERVATION_STATUS.PENDING:
		case ReservationConstants.RESERVATION_STATUS.PENDING_SUPPLIER:
		case ReservationConstants.RESERVATION_STATUS.PENDING_PAYMENT:
		case ReservationConstants.RESERVATION_STATUS.PENDING_SUPPORT:
			text = t('Statuses.Pending');
			break;
		case ReservationConstants.RESERVATION_STATUS.CANCELED:
		case ReservationConstants.RESERVATION_STATUS.CANCELLED:
			text = t('Statuses.Cancelled');
			break;
		case ReservationConstants.RESERVATION_STATUS.CANCELING:
			text = t('Statuses.Cancelling');
			break;
		case ReservationConstants.RESERVATION_STATUS.ABORTED:
			text = t('Statuses.Aborted');
			break;
		case ReservationConstants.RESERVATION_STATUS.APPROVED:
			text = isCompletedStatus(rawStatus, checkOut) ? t('Statuses.Completed') : t('Statuses.Confirmed');
			break;
		case ReservationConstants.RESERVATION_STATUS.ERROR:
			text = t('Statuses.Error');
			break;
		default:
		// Do nothing
	}

	return text;
}

function getRequestStatus(status) {
	status = status.toLowerCase();
	let text = '';

	switch (status) {
		case ReservationConstants.REQUEST_STATUS.PENDING:
			text = 'Pending';
			break;
		case ReservationConstants.REQUEST_STATUS.APPROVED:
			text = 'Approved';
			break;
		case ReservationConstants.REQUEST_STATUS.REJECTED:
			text = 'Declined';
			break;
		case ReservationConstants.REQUEST_STATUS.EXPIRED:
			text = 'Expired';
			break;
		case ReservationConstants.REQUEST_STATUS.ERROR:
			text = 'Error';
			break;
		default:
		// Do nothing
	}

	return text;
}

export default {
	getBookingStatus,
	getRequestStatus,
	isCompletedStatus,
};
